import React from "react";
import { DateTimePicker } from "@atlaskit/datetime-picker";

import { DateContainer } from "./styles";
import { useAtlassianLocale } from "@Shared/Hooks/useAtlassianLocale";
import { TIMES } from "@Shared/Components/DateTimePicker";

export const DateTime = ({ onChange = () => {}, value, timeFormat }) => {
  const [locale] = useAtlassianLocale();

  return (
    <DateContainer>
      <DateTimePicker
        locale={locale}
        value={value}
        placeholder="Add..."
        onChange={(v) => onChange(v)}
        datePickerProps={{
          locale,
          inputLabelId: "date",
          openCalendarLabel: "open calendar",
          selectProps: {
            classNamePrefix: "date-picker",
          },
        }}
        timePickerProps={{
          locale,
          timeFormat,
          times: TIMES,
        }}
      />
    </DateContainer>
  );
};
